import Vue from 'vue';
export default Vue.extend({
    name: 'fundCreateOrderGuide',
    data: function () {
        return {};
    },
    methods: {
        createOrder: function () {
            this.$router.push({
                path: 'loan-order-list/loan-create',
            });
        },
    },
});
